import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Label } from "@/components/ui/label"
import { timezoneOptions } from "@/lib/constants/timezones"

interface TimezoneSelectProps {
  value: string
  onChange: (value: string) => void
}

export const TimezoneSelect = ({ value, onChange }: TimezoneSelectProps) => {
  return (
    <div className="space-y-2">
      <Label>Timezone{" "}<span className="text-red-500">*</span></Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select timezone" />
        </SelectTrigger>
        <SelectContent>
          {timezoneOptions.map((tz) => (
            <SelectItem key={tz.value} value={tz.value}>
              {tz.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}